'use client';

import { useState, useEffect } from 'react';
import type { Project } from '@/content/projects/types';
import ProjectArticle from './ProjectArticle';

interface ProjectArticleInteractiveProps {
  project: Project;
  prevProject: Project | null;
  nextProject: Project | null;
  lang?: 'en' | 'de';
}

export default function ProjectArticleInteractive({
  project,
  prevProject,
  nextProject,
  lang = 'en',
}: ProjectArticleInteractiveProps) {
  const [currentLanguage, setCurrentLanguage] = useState<'en' | 'de'>(lang);

  useEffect(() => {
    // Update language if prop changes
    setCurrentLanguage(lang);

    const handleLanguageChange = (event: CustomEvent<{ language: 'en' | 'de' }>) => {
      setCurrentLanguage(event.detail.language);
    };

    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange as EventListener);
    };
  }, []);

  return (
    <ProjectArticle
      project={project}
      currentLanguage={currentLanguage}
      prevProject={prevProject}
      nextProject={nextProject}
    />
  );
}